"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacingStyle = exports.marginValue = exports.margin = exports.paddingValue = exports.padding = exports.PositionArray = void 0;

var _utils = require("../../utils");

var _grid = require("../grid");

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PositionArray = ['top', 'right', 'bottom', 'left'];
exports.PositionArray = PositionArray;

var padding = function padding(arr) {
  if (Array.isArray(arr)) {
    return (0, _utils.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding: ", "px !important;\n    "])), arr.join('px '));
  }

  var value = {};
  Object.keys(arr).forEach(function (key) {
    value[key] = "".concat(arr[key].join('px '), "px !important;");
  });
  return (0, _grid.map)(value, function (v) {
    return "padding: ".concat(v, ";");
  });
};

exports.padding = padding;

var paddingValue = function paddingValue(value, position) {
  return (0, _grid.map)(value, function (v) {
    return "padding-".concat(position, ": ").concat(v, "px !important;");
  });
};

exports.paddingValue = paddingValue;

var margin = function margin(arr) {
  if (Array.isArray(arr)) {
    var marginArray = arr.map(function (i) {
      return i === 'auto' ? i : "".concat(i, "px");
    });
    return (0, _utils.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin: ", " !important;\n    "])), marginArray.join(' '));
  }

  var value = {};
  Object.keys(arr).forEach(function (key) {
    value[key] = "".concat(arr[key].join('px '), "px !important;");
  });
  return (0, _grid.map)(value, function (v) {
    return "margin: ".concat(v, ";");
  });
};

exports.margin = margin;

var marginValue = function marginValue(value, position) {
  return (0, _grid.map)(value, function (v) {
    return "margin-".concat(position, ": ").concat(v === 'auto' ? v : "".concat(v, "px"), " !important;");
  });
};

exports.marginValue = marginValue;

var spacingStyle = function spacingStyle(_ref) {
  var m = _ref.m,
      mt = _ref.mt,
      mr = _ref.mr,
      mb = _ref.mb,
      ml = _ref.ml,
      p = _ref.p,
      pt = _ref.pt,
      pr = _ref.pr,
      pb = _ref.pb,
      pl = _ref.pl;
  return (0, _utils.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), (m || m === 0) && margin(m), (mt || mt === 0) && marginValue(mt, 'top'), (mr || mr === 0) && marginValue(mr, 'right'), (mb || mb === 0) && marginValue(mb, 'bottom'), (ml || ml === 0) && marginValue(ml, 'left'), (p || p === 0) && padding(p), (pt || pt === 0) && paddingValue(pt, 'top'), (pr || pr === 0) && paddingValue(pr, 'right'), (pb || pb === 0) && paddingValue(pb, 'bottom'), (pl || pl === 0) && paddingValue(pl, 'left'));
};

exports.spacingStyle = spacingStyle;